import { IBaixarPdfBoletoDepositoRequest } from '../entities/IBaixarPdfBoletoDepositoRequest'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IBaixarPdfBoletoDeposito {
  execute(data: IBaixarPdfBoletoDepositoRequest): Promise<any>
}

export default class BaixarPdfBoletoDepositoImpl
  implements IBaixarPdfBoletoDeposito
{
  constructor(private readonly pagamentosRepository: IPagamentoRepository) {}
  async execute(data: IBaixarPdfBoletoDepositoRequest): Promise<any> {
    return this.pagamentosRepository.baixarPdfBoletoDeposito(data)
  }
}
